/**
 * Citibox brand typography tokens. Body copy is Lato; phone numbers and the ⌘K
 * hint render in Roboto Mono (per Figma). The font files are loaded via
 * @fontsource in apps/shell — see docs/DESIGN.md §4.
 */
export const FONT_FAMILY_BODY = '"Lato", "Roboto", "Helvetica", "Arial", sans-serif';

export const FONT_FAMILY_DISPLAY = FONT_FAMILY_BODY;

// Monospace for IDs/phone numbers (figures align in columns).
export const FONT_FAMILY_MONO = '"Roboto Mono", "SFMono-Regular", "Menlo", "Consolas", monospace';

export const FONT_SIZE_BASE = 14; // MUI typography.fontSize default

export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
} as const;
